/* eslint-disable no-unused-vars */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import EqualizerIcon from '@material-ui/icons/Equalizer';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.indigo[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.indigo[600]
  },
}));

const TotalForms = ({ className, totalArray, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL CLIENT FORMS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {totalArray === 0 ? '......' : totalArray}&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleOutlineIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <EqualizerIcon className={classes.differenceIcon} />&nbsp;
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {/* 16% &nbsp; */}
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Count of all submitted forms
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

TotalForms.propTypes = {
  className: PropTypes.string
};

export default TotalForms;
